var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { classNames } from "@bookingcom/bui-core/utilities/classNames";
import mixinClassNames from "../../utilities/mixinClassNames.js";
import { responsiveStyles, mixinStyles, } from "@bookingcom/bui-core/utilities/styles";
import styles from "@bookingcom/bui-core/css/Box.module.css";
var Box = function (props) {
    var _a = props.padding, padding = _a === void 0 ? 4 : _a, attributes = props.attributes, orientation = props.orientation, backgroundColor = props.backgroundColor, borderColor = props.borderColor, borderRadius = props.borderRadius, overflow = props.overflow, tagName = props.tagName, className = props.className, children = props.children, mixin = props.mixin;
    var TagName = tagName || "div";
    var rootClassName = classNames(styles.root, orientation && styles["root--orientation-".concat(orientation)], backgroundColor && styles["root--background-color-".concat(backgroundColor)], borderColor && styles["root--border-color-".concat(borderColor)], borderColor && styles["root--border-width-100"], borderRadius && styles["root--border-radius-".concat(borderRadius)], overflow && styles["root--overflow-".concat(overflow)], className, mixinClassNames(mixin));
    var rootAttributes = __assign(__assign({}, attributes), { style: __assign(__assign(__assign({}, responsiveStyles(padding, "box", "padding")), ((attributes === null || attributes === void 0 ? void 0 : attributes.style) || {})), mixinStyles(mixin)) });
    return (React.createElement(TagName, __assign({}, rootAttributes, { className: rootClassName }), children));
};
export default Box;
